import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { ReportsState, getRatingsLoaded, LoadRatings, getRatingsLoading } from '../store';
import { tap, filter, map, take } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class RatingsGuard  {

    constructor(private store: Store<ReportsState>) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.checkstore(next.params.cacheKey);
    }

    checkstore(cacheKey: string): Observable<boolean> {
        return this.store.pipe(
            select(getRatingsLoaded),
            tap(loaded => {
                if (!loaded)
                    this.store.dispatch(new LoadRatings(cacheKey))
            }),
            take(1),
            map(() => true)
        );
    }
}
